<template>
  <action-dispatcher
    action="product/getProduct"
    :parameters="$route.params.id"
    class="view-product-edit-pixel"
  >
    <h5 class="text-semibold">Pixel de rastreamento</h5>

    <div class="d-flex flex-lg-row flex-column gap-4 my-6">
      <div
        v-for="box in boxes"
        :key="box.type"
        class="box"
        @click="newPixel(box.type)"
      >
        <img :src="box.img" :alt="box.name" :style="box.style" />
        <span>{{ box.name }}</span>
      </div>
    </div>

    <snow-data-table-header
      @searching="search"
      :filters="false"
      :add="false"
      :date-picker="false"
      class="mb-5"
    />

    <div class="text-center my-9" v-if="loading">
      <b-spinner variant="primary" />
    </div>

    <div
      v-else-if="!pixelList.length"
      class="container centralize-row text-center pt-9"
    >
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <img
            class="d-block mb-9 mx-auto"
            src="@/assets/images/no-content.svg"
          />
          <h5>Você ainda não adicionou um pixel</h5>
          <div class="text-secondary mb-9">
            Clique nos botões acima e adicione o primeiro
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <snow-data-table :data="pixelList" :columns="pixelColumns" />
    </div>

    <pixel-modal
      v-model="modal"
      :type="pixelType"
      :pixel="editedPixel"
      :custom-conversion-label="pixelType === 'google_ads'"
      @submit="submitPixel"
      @submitEdit="submitEditPixel"
    />
  </action-dispatcher>
</template>

<script>
import PixelModal from "@/components/product/pixel/PixelModal.vue";
import PixelMixin from "@/mixins/pixel";
import ProductActionsMixin from "@/mixins/productActions.js";
import MemberAreaMixin from "@/mixins/memberArea";

export default {
  mixins: [ProductActionsMixin, PixelMixin, MemberAreaMixin],
  components: { PixelModal },
  data() {
    return {
      boxes: [
        {
          name: "Facebook",
          img: require("@/assets/images/fb_icon-v2.svg"),
          type: "facebook"
        },
        {
          name: "Google Ads",
          img: require("@/assets/images/google_ads_icon-v2.svg"),
          type: "google_ads"
        },
        {
          name: "Google Analytics",
          img: require("@/assets/images/google_analytics_icon-v2.svg"),
          type: "google_analytics"
        },
        {
          name: "Kwai",
          img: require("@/assets/images/kwai_icon-v2.svg"),
          type: "kwai",
          style: { padding: "10px" }
        }
      ]
    };
  },
  computed: {
    pixelList() {
      if (this.search_text) {
        const res = this.product.pixel.filter(p =>
          JSON.stringify(p)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .match(this.search_text)
        );
        return res;
      }
      if (this.product && this.product.pixel) {
        return this.product.pixel;
      }

      return [];
    },
    pixelColumns() {
      return [
        {
          name: "Ferramenta",
          field: "type"
        },
        {
          name: "Pixel",
          field: "code"
        },
        {
          name: "Label de Conversão",
          field: "conversion_label"
        },
        {
          name: "",
          type: "menu",
          options: item => {
            const index = this.pixelList.indexOf(item);
            return [
              {
                label: "Editar",
                click: () => this.editPixel(item, index)
              },
              {
                label: "Excluir",
                class: "text-danger",
                variant: "danger",
                dialog: {
                  icon: "ph ph-trash",
                  text: "Deseja mesmo excluir o pixel?",
                  buttonText: "Sim, excluir",
                  secondaryButtonText: "Não, cancelar",
                  action: () => this.submitRemovePixel(index)
                }
              }
            ];
          }
        }
      ];
    },
    breadcrumbs() {
      return [
        { title: "Meus produtos", link: "product" },
        {
          title: this.product.name,
          link: "product-details",
          params: { id: this.$route.params.id }
        },
        { title: "Pixel de rastreamento" }
      ];
    }
  },
  mounted() {
    this.getMemberAreaSetup();
  }
};
</script>
<style lang="scss" scoped>
.view-product-edit-pixel {
  .box {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;

    cursor: pointer;

    padding: 24px;
    border-radius: 16px;
    background: var(--bg-1);
    border: 1px solid var(--dark-10);

    transition: 0.3s all ease-in-out;

    &:hover {
      box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.04);
    }
  }
}
</style>
